import React, { CSSProperties } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactSelect from "react-select";
import pluralize from "pluralize";
import { updateItemQuantity } from "../../../../../../store/prescription/actions";
import type { QuantitySelectorProps } from "../../types";
import StatusBadge from "../StatusBadge";
import * as Styles from "./QuantitySelectorStyles";
import { trackSelectQuantity } from "../../../../../../monitoring/interaction/prescription-detail";
import { AppState } from "../../../../../../store";
import { useTrackingProperties } from "../../../../../../monitoring/utils";

const QuantitySelector: React.FC<QuantitySelectorProps> = ({ item }) => {
  const prescriptionId = useSelector((state: AppState) => state.prescription.prescription.id);
  const { drugstoreId, chainId, drugstoreName, chainName, drugstoreUF } = useTrackingProperties();
  const dispatch = useDispatch();

  const handleQuantityChange = (
    selectedOption: { value: number | 'all'; label: string } | null,
  ) => {
    trackSelectQuantity({
      prescriptionId,
      itemId: item.id,
      quantity: selectedOption?.value ?? 0,
      drugstoreId,
      chainId,
      drugstoreName,
      chainName,
      drugstoreUF,
    });
    if (selectedOption) {
      dispatch(updateItemQuantity(item.id, selectedOption.value));
    }
  };

  const prescribedQuantity = item.prescribedQuantity ?? 0;
  const dispensedQuantity = item.dispensedQuantity ?? 0;

  const availableQuantity =
    prescribedQuantity - dispensedQuantity < 0
      ? 0
      : prescribedQuantity - dispensedQuantity;


  const generateOptions = () => {
    if (availableQuantity <= 0) return [];


    const allOption = {
      value: "all",
      label: "Todos",
    };


    const descendingOptions = Array.from(
      { length: Math.max(availableQuantity, 0) },
      (_, index) => {
        const i = availableQuantity - index;
        const label = `${i} ${pluralize(item.unit ?? "Unidade", i)}`;
        return { value: i, label };
      },
    );

    return [allOption, ...descendingOptions];
  };


  const currentValue = item.selectedQuantity ?? availableQuantity;
  const options = generateOptions();
  const selectedOption =
    options.find((opt) => opt.value === currentValue) || options[options.length - 1];

  const showSelect = item.checked && item.prescribedQuantity && item.prescribedQuantity > 0;

  return (
    <Styles.QuantitySelectorContainer>

      <StatusBadge
        dispensedAmount={item.dispensedQuantity ?? 0}
        prescribedAmount={item.prescribedQuantity ?? 0}
      />


      <Styles.SelectWrapper>
        {showSelect && (
          <ReactSelect
            instanceId={`quantity-${item.id}`}
            value={selectedOption}
            onChange={handleQuantityChange}
            options={options}
            placeholder="Selecione..."
            styles={{
              control: (base: CSSProperties) => ({
                ...base,
                width: "170px",
                minWidth: "170px",
              }),
            }}
          />
        )}
      </Styles.SelectWrapper>


      {item.checked &&
        (!item.prescribedQuantity || item.prescribedQuantity === 0) && (
          <Styles.UnavailableText>não disponível</Styles.UnavailableText>
        )}
    </Styles.QuantitySelectorContainer>
  );
};

export default QuantitySelector;